export default "__VITE_ASSET__BuUZwA15__"